<!-- attribute categories selector -->
<cxone-multiselect-dropdown class="w-100" [selection]="categoriesSelected"
    (selectionChanged)="onCategorySelectionChanged($event)" (dropdownOpened)="onCategorySelectorOpen()"
    (dropdownClosed)="onCategorySelectorClose()" [options]="attributeCategories" [label]="'name'" [primaryKey]="'id'"
    [sortOrder]="'asc'" [sortKey]="'sort'" [isLoading]="categoriesModel === null || !attributeCategories?.length"
    [isRequired]="false" [maxItemsToDisplay]="100" [maxSelectionLimit]="MAX_SELECTABLE">
</cxone-multiselect-dropdown>

<cv-repeated-selectors class="w-100" *ngIf="filledCategories != null && filledCategories.size > 0"
    [filledCategories]="filledCategories" [attributesLoading]="attributesLoading" [statedAttributes]="statedAttributes"
    [pageName]="pageName" [categoryNameIdMap]="categoryNameIdMap" [settingsManager]="settingsManager" [viewByLimitsFilters]="viewByLimitsFilters">
</cv-repeated-selectors>
